import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/organisms/layanan/layanan.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/templates/site-layout/site-layout.tsx")